<template>
  <iframe
    ref="content"
    :src="$route.query.url"
  />
</template>

<script>
export default {
  name: 'extraLink'
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100vw;
  height: 100%;
  border: none;
}
</style>




// WEBPACK FOOTER //
// src/views/help-center/views/ExternalLink.vue